import React from 'react';
import type { AutoStatusToastState } from '../../hooks/useAutoStatusToast';

interface AutoStatusToastProps {
  state: AutoStatusToastState;
  className?: string;
}

const AutoStatusToast: React.FC<AutoStatusToastProps> = ({ state, className }) => {
  if (!state) return null;

  return (
    <div
      className={['cp-toast-auto', className].filter(Boolean).join(' ')}
      role="status"
      aria-live="polite"
    >
      <div className={`cp-toast-auto-box cp-toast-auto-box-${state.kind}`}>
        {state.kind === 'saving' ? (
          <span className="cp-toast-auto-spinner" aria-hidden="true" />
        ) : state.kind === 'success' ? (
          <span className="cp-toast-auto-success-icon" aria-hidden="true">
            v
          </span>
        ) : state.kind === 'info' || state.kind === 'error' ? (
          <span className="cp-toast-auto-warning-icon" aria-hidden="true" title="주의">
            !
          </span>
        ) : null}
        <span>{state.message}</span>
      </div>
    </div>
  );
};

export default AutoStatusToast;
